import moment from 'moment';
import { AuthResponse, AuthToken } from '@/api/requests/auth/types';

/**
 * @const STORAGE_ACCESS_KEY
 */
const STORAGE_ACCESS_KEY: string = 'auth_accesstoken';

/**
 * @const STORAGE_EXPIRES_KEY
 */
const STORAGE_EXPIRES_KEY: string = 'auth_expiresat';

/**
 * @const STORAGE_REFRESH_KEY
 */
const STORAGE_REFRESH_KEY: string = 'auth_refreshtoken';

export default class ManuteAuthToken {

    /**
     * Check if token is expired
     */
    get isExpired(): boolean {
        return this.expiresAt.isBefore();
    }

    /**
     * Check if token is expired
     */
    get isValid(): boolean {
        return !!this.accessToken && !this.isExpired;
    }

    /**
     * Initialize class from local storage.
     */
    static fromStorage() {
        const accessToken = localStorage.getItem(STORAGE_ACCESS_KEY);
        if (! accessToken) { throw new Error('No access token'); }
        const expiresAt = localStorage.getItem(STORAGE_EXPIRES_KEY);
        if (! expiresAt) { throw new Error('No expiration date'); }
        const refreshToken = localStorage.getItem(STORAGE_REFRESH_KEY);
        if (! refreshToken) { throw new Error('No refresh token'); }

        return new this({
            accessToken,
            expiresAt: moment(expiresAt, 'YYYY-MM-DD HH:mm:ss'),
            refreshToken,
        });
    }

    /**
     * Initialize class from http response.
     * @param instance
     */
    static fromHttp(instance: AuthResponse) {
        return new this({
            accessToken: instance.accessToken,
            expiresAt: moment().add(instance.expiresIn, 's'),
            refreshToken: instance.refreshToken,
        });
    }

    /**
     * Remove token items from local storage.
     */
    static removeFromStorage() {
        localStorage.removeItem(STORAGE_ACCESS_KEY);
        localStorage.removeItem(STORAGE_EXPIRES_KEY);
        localStorage.removeItem(STORAGE_REFRESH_KEY);
    }
    /**
     * @var
     */
    accessToken: string;

    /**
     * @var
     */
    expiresAt: moment.Moment;

    /**
     * @var
     */
    refreshToken: string;

    /**
     * Token constructor.
     *
     * @param initializer
     */
    constructor(initializer: AuthToken) {
        this.accessToken = initializer.accessToken;
        this.expiresAt = initializer.expiresAt;
        this.refreshToken = initializer.refreshToken;
    }

    /**
     * Save current token instance to lokal storage.
     */
    toStorage() {
        localStorage.setItem(STORAGE_ACCESS_KEY, this.accessToken);
        localStorage.setItem(STORAGE_EXPIRES_KEY, this.expiresAt.format('YYYY-MM-DD HH:mm:ss'));
        localStorage.setItem(STORAGE_REFRESH_KEY, this.refreshToken);
    }
}
